import { call, put, all } from "redux-saga/effects";
import { deleteAccountPrepareEnd } from "../actions/deleteaccountactions";
import { reportError } from "../actions/erroractions";
import { deleteAccountPrepareAPI } from "../api/DeleteAccountPrepareCall";

export function* deleteAccountPrepareSaga(action) {
  try {
    const result = yield call(deleteAccountPrepareAPI, action);

    if (result.ok) {
      yield put(deleteAccountPrepareEnd());
    } else {
      yield all([
        put(reportError(result.messages)),
        put(deleteAccountPrepareEnd()),
      ]);
    }
  } catch (e) {
    yield all([
      put(reportError("Unable to reach server")),
      put(deleteAccountPrepareEnd()),
    ]);
  }
}
